import { request } from '../../../utils/request';

export default async function submitIndividualNIN(
  customerId: number,
  nin: string,
  authToken: string
): Promise<{
  success: boolean;
  message: string;
  status: 'verified' | 'rejected';
}> {
  const res = await request({
    url: '/sterling/kyc/submit/nin',
    method: 'POST',
    formData: { customer_id: customerId, nin },
    headers: { Authorization: `Bearer ${authToken}` },
  });

  if (!res.success) throw new Error(res.message);
  return res;
}
